	// sort array by field
	function arSort(prop) {
		var sortOrder = 1;
		if(prop[0] === "-") {
			sortOrder = -1;
			prop = prop.substr(1);
		}
		return function (a,b) {
			/* works with strings and numbers */
			var result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
			return result * sortOrder;
		}
	}

	function chooseOption() {
		// console.log(this)
		var item 		= this,
			optionName 	= item.innerHTML,
			option 		= item.dataset.value,
			current 	= item.parentElement.previousElementSibling,
			others 		= item.parentElement.querySelectorAll('.selected')
		if (others) {
			for (let i = 0; i < others.length; i++) {
				others[i].classList.remove('selected')
			}
		}
		current.innerHTML = optionName
		item.classList.add('selected')
		closeSelect()
		// отобразить новый порядок партнеров
		if (jsPartners) renderPartnerList(jsPartners.sort(arSort(option)))
	}

	function renderPartnerList(ar) {
		if (ar) {
			var to = document.querySelector('.partners .filter +.flex'),
				list = ''
			for (let i = 0; i < ar.length; i++) {
				if (!ar[i]['LOGO']) ar[i]['LOGO'] = ''
				list += '<div class="partner">'+
					'<div><img src="' + ar[i]['LOGO'] + '" alt="' + ar[i]['NAME'] + '"></div>'+
					'<div>'+
						'<div class="name">' + ar[i]['NAME'] + '</div>'+
						'<div class="status">' + ar[i]['STATUS'] + '</div>'+
					'</div>'+
				'</div>'
			}
			to.innerHTML = list
		}
	}